'use strict'

module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 15
// module chunks = 0